import * as types from "../../actions/actionTypes";

const initialState = {
  configName: "",
  settings: []
};

const settingsReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SETTINGS_LOAD_CONFIGNAME:
      return { ...state, configName: action.configName };
    case types.SETTINGS_LOAD_CONFIGNAME_SUCCESS:
      return { ...state, settings: action.settings };
    default:
      return state;
  }
};

export default settingsReducer;



// WEBPACK FOOTER //
// ./src/reducers/pomui/settingsReducer.js